/**
 * Git Sources API client (pull conflict resolution, Phase 5).
 */

import { fetchWithAuth } from './core';

export async function getGitSourceFileContent(gitSourceId: string, filePath: string): Promise<string> {
  const q = encodeURIComponent(filePath);
  const res = await fetchWithAuth(`/api/git-sources/${gitSourceId}/file-content?file_path=${q}`);
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error((data as { error?: string }).error ?? `Failed to fetch file (${res.status})`);
  }
  const data = (await res.json()) as { content?: string };
  if (typeof data.content !== 'string') throw new Error('Invalid file content response');
  return data.content;
}

export async function resolveGitSourceConflict(payload: {
  gitSourceId: string;
  filePath: string;
  resolution: 'upstream' | 'flownotes' | 'ai';
  aiContent?: string;
  threadId?: string;
  dbDocumentId?: string;
}): Promise<void> {
  const body: Record<string, unknown> = {
    file_path: payload.filePath,
    resolution: payload.resolution,
  };
  if (payload.threadId) body.thread_id = payload.threadId;
  if (payload.dbDocumentId) body.db_document_id = payload.dbDocumentId;
  if (payload.resolution === 'ai' && payload.aiContent != null) body.ai_content = payload.aiContent;

  const res = await fetchWithAuth(`/api/git-sources/${payload.gitSourceId}/resolve-conflict`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error((data as { error?: string }).error ?? `Conflict resolution failed (${res.status})`);
  }
}
